import { ComponentCommunicationService } from 'src/app/component-communication.service';
import { Component, Input, OnInit } from '@angular/core';
import { FormGroup } from '@angular/forms';
import { Constants } from 'src/app/constants';
import { GenderEnum } from 'src/app/model/enums/GenderEnum';
import { OptionsEnum } from 'src/app/model/enums/OptionsEnum';
import { LocationDto } from 'src/app/model/LocationDto';
import { ApplicationApiService } from 'src/app/services/applicationApiService';
import { EnumConverterService } from 'src/app/services/EnumConverterService';

@Component({
  selector: 'app-application-second-insured',
  templateUrl: './application-second-insured.component.html',
  styleUrls: ['./application-second-insured.component.css'],
})
export class ApplicationSecondInsuredComponent implements OnInit {
  @Input()
  insuredFormGroup: FormGroup;

  genderList = this.enumConverterService.toBaseList('GenderEnum', GenderEnum);

  yesNoList = this.enumConverterService.toBaseList('OptionsEnum', OptionsEnum);
  OptionsEnum = OptionsEnum;

  phonePattern = Constants.phonePattern;
  phoneMask = Constants.phoneInputMask;
  dateMask: string;
  isZipCodeLoaderShown = false;
  isEmptyZipCodeServiceResultMessageShown = false;

  constructor(
    private enumConverterService: EnumConverterService,
    private applicationApiService: ApplicationApiService,
    private componentCommunication: ComponentCommunicationService
    ) {}

  ngOnInit(): void {
    this.insuredFormGroup.get('houseNumber').valueChanges.subscribe(newValue => {
      this.updateStreetAndCity(this.insuredFormGroup.controls.zipCode.value, newValue);
    });
    this.insuredFormGroup.get('zipCode').valueChanges.subscribe(newValue => {
      this.updateStreetAndCity(newValue, this.insuredFormGroup.controls.houseNumber.value);
    });
  }

  setIsZipCodeLoaderShown(isZipCodeLoaderShown: boolean): void {
    this.isZipCodeLoaderShown = isZipCodeLoaderShown;
  }

  setIsEmptyZipCodeServiceResultMessageShown(isEmptyZipCodeServiceResultMessageShown: boolean): void {
    this.isEmptyZipCodeServiceResultMessageShown = isEmptyZipCodeServiceResultMessageShown;
  }

  updateStreetAndCity(zipCode: string, houseNo: string): void {
    if (!zipCode || zipCode === '') {
      return;
    }

    if (!houseNo || houseNo === '') {
      return;
    }

    this.setIsZipCodeLoaderShown(true);

    this.applicationApiService.getLocation(zipCode, houseNo).subscribe((location: LocationDto) => {
      this.setIsZipCodeLoaderShown(false);

      if (!location.city) {
        this.setIsEmptyZipCodeServiceResultMessageShown(true);
        return;
      }

      this.setIsEmptyZipCodeServiceResultMessageShown(false);

      if (location.city) {
        this.insuredFormGroup.get('city').patchValue(location.city);
      }

      if (location.street) {
        this.insuredFormGroup.get('street').patchValue(location.street);
      }
    });
  }

  get notSameAddress(): boolean {
    return this.insuredFormGroup.get('addressSameAsFirstInsured').value === OptionsEnum.No;
  }

  get dateMaskFormat(): string {
    return this.componentCommunication.getDateFormat();
  }
}
